export default "__VITE_ASSET__BwAvU60x__"